import ProgressBar from 'src/components/progressBar';
import Button from 'src/components/buttons/button';
import i18n from 'src/utils/translate';

type Props = {
  progress?: number;
  hideNext?: boolean;
  disabled?: boolean;
  onClickNext?: () => void;
  buttonText?: string;
}

export default function SurveyFooter({
  progress = 0,
  disabled = false,
  onClickNext = () => {},
  buttonText = 'Next',
  hideNext = false,
}: Props) {
  return (
    <div className="survey__footer">
      <div className="survey__footer-left">
        {progress}% {i18n.t('completed')}
        <ProgressBar borderRadius={16} progress={progress} />
      </div>
      {!hideNext &&
        <div className="survey__footer-right">
          <Button
            dataTestId="profile-survey__continue-button"
            disabled={disabled}
            text={<span>{buttonText}</span>}
            onClick={onClickNext}
          />
        </div>
      }
    </div>
  );
}

